import { Component } from '@angular/core';
import { ToasterService, ToasterConfig }  from 'angular2-toaster/angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
    template: '<toaster-container [toasterconfig]="toasterconfig"></toaster-container>'
  })
export class ErrorsComponent {

    @BlockUI() blockUI: NgBlockUI;
    private toasterService: ToasterService;

    public toasterconfig : ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });

    constructor(toasterService: ToasterService) {
        this.toasterService = toasterService;
    }

    error(error, context) {
        switch(error) {
            case 400 : {
                this.blockUI.stop();
                this.toasterService.pop('warning', 'Falha na requisição', 'Verifique os campos.');
            }
            break;
            case 401 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Não autorizado', 'Você não tem permissão para configurar ' + context +'.');
            }
            break;
            case 403 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Não autorizado', 'Código inválido ' + context +'.');
            }
            break;
            case 404 : {
                this.blockUI.stop();
                this.toasterService.pop('warning', 'Não existe', 'Não foi possível encontrar ' + context + '.');
            };
            break;
            case 408 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Tempo de requisição esgotado!');
            }
            break;
            case 409 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Conflito', 'Já existe este(a) ' + context + '.');
            }
            break;
            case 410 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Conflito', 'O device não suporta atualizações.');
            }
            break;
            case 412 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Conflito', 'Sem capacidade de licença.');
            }
            break;
            case 419 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Conflito', 'Já existe este o Range de Sala Virtual.');
            }
            break;
            case 420 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Conflito', 'Já existe este o Uri.');
            }
            break;
            case 500 : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Erro interno', 'Erro não especificado.');
            };
            break;
            default : {
                this.blockUI.stop();
                this.toasterService.pop('danger', 'Erro interno', 'Erro não especificado.');
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/errors/errors.component.ts